(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  const setupCollectionShowcaseHoverVideos = () => {
    const showcaseVideos = document.querySelectorAll('.indole-collection-showcase__video');
    if (!showcaseVideos.length) return;

    const playVideoInContainer = (container) => {
      const posterButton = container.querySelector('.deferred-media__poster-button');
      const htmlVideo = container.querySelector('video');

      if (posterButton && !container.dataset.hoverVideoLoaded) {
        container.dataset.hoverVideoLoaded = 'true';
        posterButton.click();
      }

      window.setTimeout(() => {
        const loadedVideo = container.querySelector('video');
        if (loadedVideo) {
          loadedVideo.muted = true;
          loadedVideo.play().catch(() => {});
        }
      }, 80);

      if (htmlVideo) {
        htmlVideo.muted = true;
        htmlVideo.play().catch(() => {});
      }
    };

    const resetVideoInContainer = (container) => {
      const htmlVideo = container.querySelector('video');
      if (!htmlVideo) return;

      htmlVideo.pause();
      try {
        htmlVideo.currentTime = 0;
      } catch (error) {
        /* no-op */
      }
    };

    showcaseVideos.forEach((container) => {
      container.addEventListener('mouseenter', () => playVideoInContainer(container));
      container.addEventListener('mouseleave', () => resetVideoInContainer(container));
    });
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      if (url.hash) {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      }

      setupCollectionShowcaseHoverVideos();
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
